import {Pipe, PipeTransform} from "@angular/core";
import {ComparatorService} from "../../services/comparator-service";
import {UebrigeBerechtigungenListEntryMeta} from "../../../core/gb-api/model/uebrigeBerechtigungenListEntryMeta";

@Pipe({
  name: 'orderByGrundstuecknrRechtId'
})
export class OrderByGrundstuecknrRechtIdPipe implements PipeTransform {

  public constructor(private comperatorService: ComparatorService) {
  }

  transform(array, ascending = true): Array<UebrigeBerechtigungenListEntryMeta> {
    return Array.from(array).sort((item1: any, item2: any) => {
      return ascending ? this.order(item1, item2) : this.order(item2, item1);
    });
  }

  private order(item1: UebrigeBerechtigungenListEntryMeta, item2: UebrigeBerechtigungenListEntryMeta) {
    let gsComp = this.comperatorService.grundstueckComparator(item1.grundstueck, item2.grundstueck);
    if (gsComp === 0) {
      gsComp = this.comperatorService.rechtIdVersionComparator(item1.rechtMaster.rechteId, item2.rechtMaster.rechteId,
        item1.rechtMaster.version.histInfo, item2.rechtMaster.version.histInfo, item1.rechtMaster.version.erstellzeitpunkt,
        item2.rechtMaster.version.erstellzeitpunkt);
    }
    return gsComp;
  }
}
